import { CardHeader, CardHeaderProps } from '@mui/material'
import { FC } from 'react'

const CardHeaderWrapper: FC<CardHeaderProps> = ({ ...props }) => <CardHeader {...props} />

export default CardHeaderWrapper
